import { render } from "./WeekSlider.vue?vue&type=template&id=65cdcb01&scoped=true"
import script from "./WeekSlider.vue?vue&type=script&lang=js"
export * from "./WeekSlider.vue?vue&type=script&lang=js"

import "./WeekSlider.vue?vue&type=style&index=0&id=65cdcb01&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cdcb01"]])

export default __exports__